import { UsbOutlined } from "@ant-design/icons";
import { Badge, Button, Select } from "antd";
import React from "react";
import classes from "./SelectSignOneApp.module.css";
import { ModalView } from "../../model/useClientSignModalState";

import { UI_ITOModuleSubTitle } from "../../../../../UI_ITO/indexUI";
import { UI_ITOModuleDocumentsList } from "../../../../../UI_ITO/UI_ITOModuleDocumentsList/UI_ITOModuleDocumentsList";
import {
  CertificateOption,
  useCSPSelectOptions,
} from "../../../../../utils/utilities/crypto-pro/useCSPSelectOptions";
import { useGetDocumentsForSigningQuery } from "../../../../../store/api/applicationBankApi/signing.api";

interface SelectSignOneAppProps {
  startSigning: (applicationId: number, thumbprint: string) => Promise<void>;
  closeModal: () => void;
  setModalView: (view: ModalView) => void;
  applicationBankId: number;
}

export const SelectSignOneApp = ({
  closeModal,
  startSigning,
  applicationBankId,
}: SelectSignOneAppProps) => {
  const { Option } = Select;

  const { certificatesOptions } = useCSPSelectOptions();

  const [thumbprint, setThumbprint] = React.useState(""); // отпечаток ЭЦП

  const { data: documentsForSigningData } =
    useGetDocumentsForSigningQuery(applicationBankId);
  const documentsForSigning = documentsForSigningData?.documents;
  const documentsToSignCount = documentsForSigning?.length || 0; // количество документов для подписания

  // Выбор подписи
  const handleSelectSign = (value: string) => {
    setThumbprint(value);
  };

  return (
    <>
      <div className={classes.wrapperModalSign}>
        <label className={classes.clientLoginFormLabel}>
          <span className={classes.signLableTitle}>Выберите ЭЦП</span>
          <Select
            size="large"
            onChange={handleSelectSign}
            placeholder={
              <React.Fragment>
                <UsbOutlined />
                &nbsp; <span className={classes.selectInput}> ЭЦП... </span>
              </React.Fragment>
            }
          >
            {certificatesOptions?.map(
              (certificatesOption: CertificateOption) => {
                return (
                  <Option
                    key={certificatesOption.thumbprint}
                    value={certificatesOption.thumbprint}
                  >
                    <div style={{ fontSize: "15px", padding: "3px" }}>
                      {certificatesOption.owner}
                    </div>
                  </Option>
                );
              }
            )}
          </Select>
        </label>
        <h3 style={{ marginTop: 5 }}>
          Неподписанные документы
          <Badge
            count={documentsToSignCount}
            color="blue"
            style={{ marginLeft: "10px" }}
          />
        </h3>
        <div style={{ height: 350, overflowY: "auto", padding: "0 26px 0 0" }}>
          <UI_ITOModuleSubTitle title={"Документы для подписания"} />
          {!!documentsForSigning?.length && (
            <UI_ITOModuleDocumentsList
              docs={documentsForSigning}
              applicationBankId={applicationBankId}
            />
          )}
        </div>
        <div className={classes.buttons}>
          <Button onClick={closeModal}>Отмена</Button>
          <Button
            disabled={!thumbprint}
            onClick={() =>
              documentsForSigning && startSigning(applicationBankId, thumbprint)
            }
            type="primary"
          >
            Начать процесс подписания
          </Button>
        </div>
      </div>
    </>
  );
};
